var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header-wrapper',{attrs:{"title":"代客创建订单"}},[_c('a-card',{attrs:{"bordered":false}},[_c('cs-order-create-form',{attrs:{"initial-user-id":_vm.$route.query.userId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }